module.exports = __webpack_public_path__ + "static/06-53d68765d4fa572c2f18270b0bb6aff5.jpg";